import auth0 from 'auth0-js'
import axios from 'axios'

export default class Auth {
	constructor() {
		this.auth0 = new auth0.WebAuth({
			domain: 'auth.globalcitizenyear.org',
			clientID: process.env.CLIENT_ID,
			redirectUri: process.env.REDIRECT_URI,
			audience: 'https://global-citizen-year.auth0.com/api/v2/',
			responseType: 'token id_token',
			scope:
				'openid email profile read:current_user create:user_metadata update:current_user_metadata'
		})

		this.gaParams = this.get_ga_params()
	}

	getCookie(cname) {
		var name = cname + '='
		var decodedCookie = decodeURIComponent(document.cookie)
		var ca = decodedCookie.split(';')

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i]
			while (c.charAt(0) == ' ') {
				c = c.substring(1)
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length).replace('%20g', ' ')
			}
		}
		return ''
	}

	get_ga_params() {
		var utmz = this.getCookie('__utmz')
		var vals = (function() {
			var pairs = utmz
				.split('.')
				.slice(4)
				.join('.')
				.split('|')
			var ga = {}
			for (var i = 0; i < pairs.length; i++) {
				var temp = pairs[i].split('=')
				ga[temp[0]] = temp[1]
			}
			return ga
		})()
		return vals
	}

	login() {
		const { gaParams } = this
		this.auth0.authorize({
			utm_medium: gaParams.utmcmd ? gaParams.utmcmd : '--',
			utm_source: gaParams.utmcsr ? gaParams.utmcsr : '--',
			utm_term: gaParams.utmctr ? gaParams.utmctr : '--',
			utm_content: gaParams.utmcct ? gaParams.utmcct : '--',
			utm_campaign: gaParams.utmccn ? gaParams.utmccn : '--'
		})
	}

	signup() {
		const { gaParams } = this
		this.auth0.authorize({
			initialScreen: 'signup',
			utm_medium: gaParams.utmcmd ? gaParams.utmcmd : '--',
			utm_source: gaParams.utmcsr ? gaParams.utmcsr : '--',
			utm_term: gaParams.utmctr ? gaParams.utmctr : '--',
			utm_content: gaParams.utmcct ? gaParams.utmcct : '--',
			utm_campaign: gaParams.utmccn ? gaParams.utmccn : '--'
		})
	}

	handleAuthentication() {
		// console.log(this.auth0)
		this.auth0.parseHash((err, authResult) => {
			// console.log('err == ', err, ' auth result === ', authResult)
			if (authResult && authResult.accessToken && authResult.idToken) {
				this.auth0.client.userInfo(authResult.accessToken, (err, user) => {
					if (err) {
						window.alert(
							'Oops, there was an error with your login attempt. Please reload the page and try again.'
						)
						this.logout()
						window.location.replace('/apply/')
					} else {
						this.setSession(authResult, user)
						// identify in segment
						// window.analytics.identify(user.email, {
						//     'email':user.email
						// }, function() {
						window.location.replace('/apply/')
						// })
					}
				})
			} else {
				// window.alert(
				// 	'auth0 = ',
				// 	this.auth0,
				// 	' err = ',
				// 	err,
				// 	' authResult = ',
				// 	authResult
				// )
				// alert('error here')
				this.logout()
				window.location.replace('/apply/')
			}
			if (err) {
				// alert('error here')
				this.logout()
				window.location.replace('/apply/')
			}
		})
	}

	setSession(authResult, user) {
		// Set the time that the Access Token will expire at
		localStorage.setItem('user_info', JSON.stringify(user))
		localStorage.setItem('account_created', true)
		let expiresAt = JSON.stringify(
			authResult.expiresIn * 1000 + new Date().getTime()
		)
		localStorage.setItem('access_token', authResult.accessToken)
		localStorage.setItem('id_token', authResult.idToken)
		localStorage.setItem('expires_at', expiresAt)
	}

	logout() {
		// Clear Access Token and ID Token from local storage
		localStorage.removeItem('access_token')
		localStorage.removeItem('id_token')
		localStorage.removeItem('expires_at')
		localStorage.removeItem('user_info')
		localStorage.removeItem('user_meta')
		localStorage.removeItem('account_created')
		this.auth0.logout({
			returnTo: 'https://www.globalcitizenyear.org/apply/',
			client_id: process.env.CLIENT_ID
		})
	}

	isAuthenticated() {
		// Check whether the current time is past the
		// Access Token's expiry time
		let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
		return new Date().getTime() < expiresAt
	}
}



// WEBPACK FOOTER //
// ./src/components/Auth/index.js